export default "__VITE_ASSET__D34UpVOj__"